import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bankingType'
})
export class BankingTypePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value == 'C') {
      return 'Consumer';
    } else if (value == 'B') {
      return 'Business';
    }
  }

}
